import { useState } from "react";
import Binga from "./Binga";
import Resa from "./Resa";
import ResaAnalyse from "./ResaAnalyse";
import ResaMobile from "./ResaMobile";
import BingaMobile from "./BingaMobile";
import { GoogleLogin, googleLogout } from '@react-oauth/google';


function App() {
  const API_URL = process.env.REACT_APP_API_URL; // change selon ton backend
  const [activeApp, setActiveApp] = useState("binga"); // valeur par défaut
  const [idToken, setIdToken] = useState("");
  const [username, setUsername] = useState("");

  const handleLoginSuccess = (credentialResponse) => {
    const token = credentialResponse.credential;
    console.log("Jeton d'identité reçu :", token);
    setIdToken(token);
    fetchUsername(token);
  };

  const fetchUsername = async (token) => {
    try {
      const res = await fetch(`${API_URL}/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });

      if (!res.ok) {
        throw new Error(`Erreur ${res.status}: ${await res.text()}`);
      }

      const data = await res.json();
      console.log("Réponse backend :", data);
      setUsername(data.user_name);
    } catch (error) {
      console.error("Erreur lors de la récupération du username :", error);
    }
  };

  const handleLogout = () => {
    googleLogout(); // <-- fonction officielle de @react-oauth/google
    setIdToken("");
    setUsername("");
    console.log("Utilisateur déconnecté");
  };


  return (
    <div className="min-h-screen bg-gray-100">
      {/* --- Auth --- */}
        {!username && (
          <div className="p-4 bg-gray-100 rounded-md shadow-md">
            <GoogleLogin
              onSuccess={handleLoginSuccess}
              onError={() => console.log("Login Failed")}
              width="250"
            />
          </div>
        )}
      {/* --- Bannière --- */}
      {username && (
        <div className="bg-gray-800 text-white p-4 flex justify-center gap-4">
          <button
            className={`px-4 py-2 rounded ${activeApp === "binga" ? "bg-blue-500" : "bg-gray-600"}`}
            onClick={() => setActiveApp("binga")}
          >
            Binga
          </button>
          <button
            className={`px-4 py-2 rounded ${activeApp === "resa" ? "bg-green-500" : "bg-gray-600"}`}
            onClick={() => setActiveApp("resa")}
          >
            Resa
          </button>
          <button
            className={`px-4 py-2 rounded ${activeApp === "resa-analyse" ? "bg-purple-500" : "bg-gray-600"}`}
            onClick={() => setActiveApp("resa-analyse")}
          >
            Resa A
          </button>
          <button
            className={`px-4 py-2 rounded ${activeApp === "binga-mobile" ? "bg-green-500" : "bg-gray-600"}`}
            onClick={() => setActiveApp("binga-mobile")}
          >
            BingaM
          </button>
          <button
            className={`px-4 py-2 rounded ${activeApp === "resa-mobile" ? "bg-green-500" : "bg-gray-600"}`}
            onClick={() => setActiveApp("resa-mobile")}
          >
            ResaM
          </button>

          <div className="flex items-center gap-4">
            <p className="text-green-600">
              ✅ <strong>{username}</strong>
            </p>
            <button
              onClick={handleLogout}
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            >
              Déconnexion
            </button>
          </div>

        </div>
      )}

      {/* --- Contenu dynamique --- */}
      <div className="p-6">
        {username && activeApp === "binga" && <Binga token={idToken} />}
        {username && activeApp === "resa" && <Resa token={idToken} />}
        {username && activeApp === "resa-analyse" && <ResaAnalyse token={idToken} />}
        {username && activeApp === "binga-mobile" && <BingaMobile token={idToken} />}
        {username && activeApp === "resa-mobile" && <ResaMobile token={idToken} />}
      </div>
    </div>
  );
}

export default App;
